namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_vk_posts_plots, {

		Charts: {
			gap: '1rem',
		},
		
	} )
	
}
